import gql from 'graphql-tag';
import {UserFullFragment} from "../fragments/UserFullFragment";

export const UserEditQuery = gql`
	query UserEditQuery($id: ID!) {
		entity: node (id: $id) {
				...UserFullFragment
		  }
	}
	${UserFullFragment}
`;


